import { render } from "./Investigation.vue?vue&type=template&id=a129218a&scoped=true&bindings={}"
import script from "./Investigation.vue?vue&type=script&lang=js"
export * from "./Investigation.vue?vue&type=script&lang=js"

import "./Investigation.vue?vue&type=style&index=0&id=a129218a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a129218a"

export default script